module.exports = __webpack_public_path__ + "static/media/S (94).6f818020.jpg";